import AmbianceActeFour from "./sfx/AmbianceActeFour"
import InterestPoints from "./sfx/InterestPoints"
import Ovni from "./sfx/Ovni"

export default function Sfx() {
 return (
  <>
    <Ovni />
    <InterestPoints />
    <AmbianceActeFour />
  </>
 )
}
